import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

export const PageLayout = (props) => (
  <div className="h-screen w-screen min-h-screen overflow-y-auto">
    <nav className="text-white mt-0">
      <Navbar />
    </nav>
    <div className="flex bg-custom-image bg-cover" >
      <div className="hidden lg:flex xl:w-[25%] 2xl:w-[20%] bg-gray-200">
        <Sidebar />
      </div>
      <div className="xl:w-[75%] 2xl:w-[80%]">
        <div className="overflow-y-auto h-full">
          {props.children}
        </div>
      </div>
    </div>
  </div>
);